import { Routes } from '@angular/router';

export const clientRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./projects/projects.component').then((m) => m.ProjectsComponent),
    pathMatch: 'full',
  },
  {
    path: 'projects',
    loadComponent: () => import('./projects/projects.component').then((m) => m.ProjectsComponent),
  },
  {
    path: 'project/create',
    loadComponent: () =>
      import('./project-editor/project-editor.component').then((m) => m.ProjectEditorComponent),
  },
  {
    path: 'project/edit/:id',
    loadComponent: () =>
      import('./project-editor/project-editor.component').then((m) => m.ProjectEditorComponent),
  },
  {
    path: 'project/:id',
    loadComponent: () =>
      import('./project-details/project-details.component').then((m) => m.ProjectDetailsComponent),
  },
  {
    path: 'requests',
    loadComponent: () =>
      import('../requests/components/service-request-list/service-request-list.component').then(
        (m) => m.ServiceRequestListComponent
      ),
  },
  {
    path: 'services',
    loadComponent: () =>
      import('./list-services/list-services.component').then((m) => m.ListServicesComponent),
  },
];
